<template lang="html">
  <div class="im-info" v-if="groupInfo.businessKey">
    <div class="im-info-inner">
      <div class="im-info-title">
        <img src="../../../assets/images/dash.png" />
        <p>{{ inviteText }}</p>
        <img class="rotate" src="../../../assets/images/dash.png" />
      </div>
      <div class="im-info-warp">
        <div class="im-info-name">
          <img :src="$$viewImage(groupInfo.groupAvatar, 60, 60)" />
          <p class="ui-nowrap">{{ groupInfo.groupName }}</p>
        </div>
        <div class="im-info-desc ui-nowrap" v-if="groupInfo.groupRemark">
          {{ groupInfo.groupRemark }}
        </div>
      </div>
      <button
        class="im-info-button"
        @click="openIm"
        v-if="this.groupInfo.inGroupFlag"
      >
        {{ btText }}
      </button>
      <button class="im-info-button" @click="addIm" v-else>{{ btText }}</button>
    </div>
  </div>
</template>

<script>
import { Msgbox } from 'kf-component-vue'

export default {
  props: {
    groupId: {
      type: String,
      default: ''
    },
    uid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      // isMiniProgram: this.$route.query.isMiniProgram === 'true',
      inviteText: '邀请您入群',
      btText: '一键加群',
      groupInfo: {}
    }
  },
  methods: {
    openIm() {
      if (this.$$isHZWApp()) {
        location.href = `https://shequ.cekid.com/update.html?cmd=imgroup&businesskey=${this.groupInfo.businessKey}`
      } else {
        this.openImInBrowser()
      }
    },
    async addIm() {
      this.$$ensureLogin()
      const json = await this.$store.dispatch('addImGroup', {
        uid: this.$$cookie('uid'),
        groupId: this.groupInfo.businessKey
      })
      console.log(json)
      if (
        json.code === '0' ||
        json.code === '200203' ||
        json.code === '200204'
      ) {
        // 200203 您已经以员工身份加入了群聊
        // 200204 您已经以会员身份加入了群聊
        this.groupInfo.inGroupFlag = true
        this.inviteText = '已加入群'
        this.btText = '打开群聊'
        if (this.$$isHZWApp()) {
          this.openImInApp()
        } else {
          this.openImInBrowser('加入成功')
        }
      } else {
        this.$$toast(json.msg)
      }
    },
    async getImInfoByUid() {
      const res = await this.$store.dispatch('getImGroupByUid', {
        uid: this.uid,
        fromUserId: this.$$cookie('uid')
      })
      // console.log(res);
      if (res.code === '0') {
        this.groupInfo = res.content.result || {}
        this.groupInfo.groupAvatar =
          this.groupInfo.groupAvatar ||
          'https://cmspic-10004025.image.myqcloud.com/c74fb940-59ba-11e8-b847-cd29773eab5a_size_80x80'
        if (this.groupInfo.inGroupFlag) {
          this.inviteText = '已加入群'
          this.btText = '打开群聊'
        } else {
          this.inviteText = '邀请您入群'
          this.btText = '一键加群'
        }
      }
    },
    async getImInfo() {
      const json = await this.$store.dispatch('getImInfo', {
        uid: this.$$cookie('uid'),
        groupId: this.groupId
      })
      console.log(json)
      if (json.code === '0') {
        this.groupInfo = json.content.result || {}
        this.groupInfo.groupAvatar =
          this.groupInfo.groupAvatar ||
          'https://cmspic-10004025.image.myqcloud.com/c74fb940-59ba-11e8-b847-cd29773eab5a_size_80x80'
        if (this.groupInfo.inGroupFlag) {
          this.inviteText = '已加入群'
          this.btText = '打开群聊'
        } else {
          this.inviteText = '邀请您入群'
          this.btText = '一键加群'
        }
      }
    },
    openImInApp() {
      Msgbox({
        title: '加入成功',
        message: '您可在“孩子王特卖-消息列表”中找到此群',
        showCancelButton: true,
        confirmButtonText: '打开群聊',
        cancelButtonText: '知道了',
        confirmButtonClass: 'comment-confirm',
        type: 'confirm',
        action: msgbox => {
          location.href = `https://shequ.cekid.com/update.html?cmd=imgroup&businesskey=${this.groupInfo.businessKey}`
        },
        cancel: msgbox => {}
      })
    },
    openImInBrowser(title = '') {
      Msgbox({
        title,
        message: '您可在“孩子王特卖-消息列表”中找到此群',
        confirmButtonText: '知道了'
      })
    }
  },
  created() {
    if (this.groupId) {
      this.getImInfo()
    } else if (this.uid) {
      this.getImInfoByUid()
    }
  }
}
</script>
<style lang="scss">
@import '../../../assets/css/mixin.scss';
.kfcv-msgbox-message {
  font-size: rem(28px) !important;
  color: #666666 !important;
}

.mint-msgbox-confirm {
  color: #ff397e !important;
}
.kfcv-msgbox-title {
  font-size: rem(36px) !important;
  font-weight: 400 !important;
  color: #121212 !important;
}
</style>
<style lang="scss" scoped>
@import '../../../assets/css/mixin.scss';

.im-info {
  background: #fff;
  padding: 0 rem(13px);
  width: 100%;
  text-align: center;

  .im-info-inner {
    @include border(top, $style: dashed);
    padding: rem(34px) 0;
  }

  .im-info-title {
    // padding-left:rem(233);
    width: 100%;
    height: rem(45px);
    display: flex;
    align-items: center;
    font-size: rem(32px);
    color: #333333;
    justify-content: center;

    img {
      width: rem(50px);
      height: auto;
      margin: 0;
      border-radius: 0;
    }
    .rotate {
      transform: rotate(180deg);
    }
    p {
      width: rem(168px);
    }
  }
  .im-info-name {
    padding-top: rem(21px);
    display: flex;
    align-items: center;
    height: rem(81px);
    font-size: rem(34px);
    color: #ff6ea2;
    justify-content: center;

    img {
      width: rem(60px);
      height: rem(60px);
      border-radius: 50%;
      margin-top: 0;
    }

    p {
      //   flex:1;
      max-width: rem(620px);
      margin-left: rem(9px);
      line-height: 0.6rem;
    }
  }

  .im-info-desc {
    font-size: rem(28px);
    color: #999999;
  }
  .im-info-button {
    margin-top: rem(13px);
    width: rem(180px);
    height: rem(70px);
    background: #ff6ea2;

    font-size: rem(28px);
    color: #ffffff;
    text-align: center;
    line-height: rem(70px);
  }
}
</style>
